module.exports = __webpack_public_path__ + "img/시설이용고령자.191ec9d7.png";